import * as angular from 'angular';
import { config } from 'angular/utils/config';

export interface BundleChangeRequestResource extends ng.resource.IResourceClass<
    ng.resource.IResource<BundleChangeRequestDto>
> {
    getBundleRequestConversation: ng.resource.IResourceMethod<
        ng.resource.IResource<BundleChangeRequestDto>
    >;
    getInitialBundleChangeRequest: ng.resource.IResourceMethod<
        ng.resource.IResource<BundleChangeRequestDto>
    >;
    createBundleChangeRequest: ng.resource.IResourceMethod<
        ng.resource.IResource<BundleChangeRequestDto>
    >;
    getBundleChangeRequests: ng.resource.IResourceMethod<
        ng.resource.IResource<BundleChangeRequestDto>
    >;
}

function bundleChangeRequestResource(
    $resource: ng.resource.IResourceService
): BundleChangeRequestResource {
    return <BundleChangeRequestResource>$resource(
        config.monolithApi + '/bundle-change-request/',
        {},
        {
            getBundleRequestConversation: {
                method: 'GET',
                url:
                    config.monolithApi +
                    '/bundle-change-request/conversation/:conversationId',
                isArray: true
            },
            getInitialBundleChangeRequest: {
                method: 'GET',
                url:
                    config.monolithApi +
                    '/bundle-change-request/:bundleRefId/initial',
                isArray: false
            },
            createBundleChangeRequest: {
                method: 'POST',
                url:
                    config.monolithApi +
                    '/bundle-change-request/:bundleIdentifier'
            },
            getBundleChangeRequests: {
                method: 'GET',
                url: config.monolithApi + '/bundle-change-request/requests',
                isArray: true
            }
        }
    );
}

angular
    .module('app')
    .factory('bundleChangeRequestResource', bundleChangeRequestResource);
